<div class="row">
  <div class="col">
    <div class="card">
      <div class="card-header">
        <h3>{{'lang.globals.settings' | translate}}</h3>

        <div class="header-more">
          <nav #nav="ngbNav" class="nav-tabs" ngbNav>
            <ng-container ngbNavItem>
              <a ngbNavLink>
                <sb-icon class="mr-2" icon="setting"></sb-icon>
                {{'lang.globals.userSettings' | translate}}
              </a>
              <ng-template ngbNavContent>
                @let userSettings = parsedUserSettings();
                <ng-container *ngIf="userSettings !== []">
                  <div class="row">
                    <div class="col">
                      <button type="button" (click)="toggleDebugMode()" [disabled]="loading"
                              class="m-0 btn + {{debugMode? 'btn-danger' :'btn-success'}}">
                        <sb-icon icon="experimental"></sb-icon>&nbsp;
                        <span class="d-none d-sm-inline-block"> {{ 'lang.globals.debugMode' | translate }}</span>
                      </button>
                    </div>
                    <div class="col">
                      <button type="button" (click)="factoryResetUserSettings()" [disabled]="loading" class="btn btn-danger m-0">
                        <sb-icon icon="history"></sb-icon>&nbsp;
                        <span class="d-none d-sm-inline-block"> {{ 'lang.globals.factoryReset' | translate }}</span>
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <table class="table">
                        <thead>
                        <tr>
                          <th>{{'lang.globals.name' | translate}}</th>
                          <th>{{'lang.globals.value' | translate}}</th>
                          <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let setting of userSettings; index as i; last as last; trackBy: trackByProperty('name')">
                          <td>
                            {{'lang.settings.' + setting.name | translate}}
                          </td>
                          <td>
                            <ng-container
                              *ngIf="setting?.isColumnSetting|| setting?.isLanguageSetting || setting?.isViewSetting else theElse">
                              <div *ngIf="setting?.isColumnSetting" class="d-flex flex-row">
                                <ng-container *ngFor="let column of setting?.parsed; index as i; last as last">
                                  <div *ngIf="i < 4"
                                       [ngClass]="i < 4 && !last ? 'border-dashed-right' : ''"
                                       class="d-flex align-items-center px-1">
                                    <button [ngbTooltip]="column?.id" class="btn white grey-bg"
                                            placement="top" container="body"
                                            style="box-shadow: 0 2px 4px 0 rgba(90,141,238,.5)">
                                      <sb-icon icon="list"></sb-icon>
                                      <span [innerHTML]="column?.id | truncate: 8"
                                            class="ml-1"></span>
                                    </button>
                                  </div>
                                  <span *ngIf="i === 4" class="ml-1 mt-3">
                                  ({{ 'lang.globals.countMore' | translate: {count: setting?.parsed?.length - 4} }})
                                </span>
                                </ng-container>
                              </div>
                              <ng-container *ngIf="setting?.isLanguageSetting">
                                <ng-container [ngSwitch]="setting?.value">
                                  <img *ngSwitchCase="'de'" [ngbTooltip]="'Deutsch'"
                                       alt="Deutsch" container="body"
                                       class="pic mr-3"
                                       placement="top"
                                       src="./assets/img/162-germany.svg" width="30"/>
                                  <img *ngSwitchCase="'en'" [ngbTooltip]="'English'"
                                       alt="English" container="body"
                                       class="pic mr-3"
                                       placement="top"
                                       src="./assets/img/226-united-states.svg" width="30"/>
                                  <ng-container *ngSwitchDefault>? ? ?</ng-container>
                                </ng-container>
                              </ng-container>
                              <ng-container *ngIf="setting?.isViewSetting">
                                {{setting?.value}}
                              </ng-container>
                            </ng-container>
                            <ng-template #theElse>
                              {{setting.value}}
                            </ng-template>
                          </td>
                          <td class="text-end">
                            <sb-button (submitClicked)="clearUserSetting(setting.name)"
                                       classes="btn-danger btn-sm actionbutton">
                              <sb-icon icon="trash"></sb-icon>
                            </sb-button>
                            <sb-button *ngIf="false" classes="btn-primary btn-sm actionbutton">
                              <sb-icon icon="edit"></sb-icon>
                            </sb-button>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </ng-container>
              </ng-template>
            </ng-container>
            <ng-container ngbNavItem>
              <a ngbNavLink>
                <sb-icon class="mr-2" icon="companyClient"></sb-icon>
                {{ 'lang.globals.userClientSettings' | translate }}
              </a>
              <ng-template ngbNavContent>
                @let clientSettings = parsedUserClientSettings();
                <ng-container *ngIf="clientSettings !== []">
                  <div class="row">
                    <div class="col">
                      <button type="button" (click)="factoryResetUserClientSettings()" [disabled]="loading" class="btn btn-danger m-0">
                        <sb-icon icon="history"></sb-icon>&nbsp;
                        <span class="d-none d-sm-inline-block"> {{ 'lang.globals.factoryReset' |translate }}</span>
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <table class="table">
                        <thead>
                        <tr>
                          <th>{{'lang.globals.name' | translate}}</th>
                          <th>{{'lang.globals.value' | translate}}</th>
                          <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let setting of clientSettings; index as i; last as last">
                          <td>
                            {{'lang.settings.' + setting.name | translate}}
                          </td>
                          <td>
                            <ng-container
                              *ngIf="setting?.isColumnSetting|| setting?.isLanguageSetting else theElse">
                              <div *ngIf="setting?.isColumnSetting"
                                   class="d-flex flex-row">
                                <ng-container
                                  *ngFor="let column of setting?.parsed; index as i; last as last">
                                  <div *ngIf="i < 4"
                                       [ngClass]="i < 4 && !last ? 'border-dashed-right' : ''"
                                       class="d-flex align-items-center px-1">
                                    <button [ngbTooltip]="column?.id" class="btn white grey-bg"
                                            placement="top" container="body"
                                            style="box-shadow: 0 2px 4px 0 rgba(90,141,238,.5)">
                                      <sb-icon icon="list"></sb-icon>
                                      <span [innerHTML]="column?.id | truncate: 8"
                                            class="ml-1"></span>
                                    </button>
                                  </div>
                                  <span *ngIf="i === 4" class="ml-1 mt-3">
                                  ({{ 'lang.globals.countMore' | translate: {count: setting?.parsed?.length - 4} }})
                                </span>
                                </ng-container>
                              </div>
                              <ng-container *ngIf="setting?.isLanguageSetting">
                                <ng-container [ngSwitch]="setting?.value">
                                  <img *ngSwitchCase="'de'" [ngbTooltip]="'Deutsch'"
                                       alt="Deutsch" container="body"
                                       class="pic mr-3"
                                       placement="top"
                                       src="./assets/img/162-germany.svg" width="30"/>
                                  <img *ngSwitchCase="'en'" [ngbTooltip]="'English'"
                                       alt="English" container="body"
                                       class="pic mr-3"
                                       placement="top"
                                       src="./assets/img/226-united-states.svg" width="30"/>
                                  <ng-container *ngSwitchDefault>? ? ?</ng-container>
                                </ng-container>
                              </ng-container>
                              <ng-container *ngIf="setting?.isViewSetting">
                                {{setting?.value?.local ? setting?.value?.local : setting?.value?.global ? setting?.value?.global : 'list'}}
                              </ng-container>
                            </ng-container>
                            <ng-template #theElse>
                              {{setting.value}}
                            </ng-template>
                          </td>
                          <td class="text-end">
                            <sb-button (submitClicked)="clearUserClientSetting(setting.name)"
                                       classes="btn-danger btn-sm actionbutton">
                              <sb-icon [icon]="'trash'"></sb-icon>
                            </sb-button>
                            <sb-button *ngIf="false" classes="btn-primary btn-sm actionbutton">
                              <sb-icon [icon]="'edit'"></sb-icon>
                            </sb-button>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </ng-container>
              </ng-template>
            </ng-container>
          </nav>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col">
            <div class="tw-min-h-[400px] tw-overflow-x-hidden">
              <div [ngbNavOutlet]="nav"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
